import {PageReloadContext} from "components/src/context/PageReloadContextProvider";
import {useContext} from 'react'

/**
 * The reload context of the current page. Outside PageReloadContextProvider it does nothing, so a page header or
 * sidebar outside the application layout keeps working.
 */
export function usePageReloadContext()
{
    return useContext(PageReloadContext);
}
